export const WHATSAPP_NUMBER = '5544999491158';

export const WHATSAPP_MESSAGE = encodeURIComponent(
  'Olá! Vi o site da Mafra Tintas e gostaria de saber mais sobre os produtos.'
);

export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

export const buildWhatsAppLink = (productName) => {
  const message = encodeURIComponent(
    `Olá! Gostaria de comprar ${productName} da Mafra Tintas.`
  );

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
};
